module.exports = __webpack_public_path__ + "static/media/VDWXRTKC2.08b8c2a6.png";